import React from 'react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import Contact from '../components/Contact';
import { contact } from '../data/mock';

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact"
        description="Talk to Salihi Consulting Services. Call +252 77 2007777 or email info@salihiconsulting.com. Office: 1st Floor, Blue Building, Opp ABC Centre, Aden Abdulle International Airport, Mogadishu."
        path="/contact"
        keywords="contact Salihi Consulting, Mogadishu consulting firm, book consultation Somalia"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: 'Contact Salihi Consulting',
          url: 'https://salihiconsulting.com/contact',
          mainEntity: {
            '@type': 'Organization',
            '@id': 'https://salihiconsulting.com/#organization',
            telephone: contact.phone,
            email: contact.email,
          },
        }}
      />
      <PageHero
        breadcrumb="Contact"
        eyebrow="Get in touch"
        title="Let’s discuss what your organization"
        italicTitle="needs to do next."
        subtitle="Whether you are scoping a new initiative, navigating a complex compliance matter, or preparing for capital, our senior team is ready to help you think through the next step."
      />
      <Contact heading={false} />
    </>
  );
}
